<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-content class="ion-padding-bottom">
  <div class="select-guest-container ion-padding-horizontal">
    <button class="select-guest-btn" (click)="selectfromGuestList()">
      {{ "shared.passenger_detail_form_v2.select_guests_btn" | translate }}
    </button>
  </div>
  <form [formGroup]="passengerForm" class="formCls">
    <ion-grid class="ion-padding">
      <div
        class="gender-section"
        [class.field-error]="
          passengerForm.get('Gender')?.invalid &&
          passengerForm.get('Gender')?.touched
        "
      >
        <label class="gender-label"
          >{{ "shared.passenger_detail_form_v2.gender" | translate }} <span class="required-asterisk">*</span></label
        >
        <div class="gender-buttons">
          <button
            type="button"
            class="gender-btn"
            [class.gender-btn-selected]="
              passengerForm.get('Gender')?.value === 'Male'
            "
            (click)="selectGender('Male')"
          >
            {{ "shared.passenger_detail_form_v2.male" | translate }}
          </button>
          <button
            type="button"
            class="gender-btn"
            [class.gender-btn-selected]="
              passengerForm.get('Gender')?.value === 'Female'
            "
            (click)="selectGender('Female')"
          >
            {{ "shared.passenger_detail_form_v2.female" | translate }}
          </button>
          <!-- <button
            type="button"
            class="gender-btn"
            [class.gender-btn-selected]="
              passengerForm.get('Gender')?.value === 'Other'
            "
            (click)="selectGender('Other')"
          >
            {{ "shared.passenger_detail_form_v2.other" | translate }}
          </button> -->
        </div>
      </div>
      <ion-select
        formControlName="Title"
        name="Title"
        [placeholder]="'shared.passenger_detail_form_v2.title_placeholder' | translate"
        interface="popover"
        class="ion-no-padding primary-select ion-margin-bottom fs-4"
        [class.field-error]="
          passengerForm.get('Title')?.invalid &&
          passengerForm.get('Title')?.touched
        "
      >
        <ion-select-option value="Mr">{{ "shared.passenger_detail_form_v2.mr" | translate }}</ion-select-option>
        <ion-select-option value="Mrs">{{ "shared.passenger_detail_form_v2.mrs" | translate }}</ion-select-option>
        <ion-select-option value="Ms">{{ "shared.passenger_detail_form_v2.ms" | translate }}</ion-select-option>
        <ion-select-option *ngIf="type !== 'adult'" value="Miss"
          >{{ "shared.passenger_detail_form_v2.miss" | translate }}</ion-select-option
        >
        <ion-select-option *ngIf="type !== 'adult'" value="Mstr"
          >{{ "shared.passenger_detail_form_v2.mstr" | translate }}</ion-select-option
        >
        <ion-select-option *ngIf="type === 'adult'" value="Dr">{{ "shared.passenger_detail_form_v2.dr" | translate }}</ion-select-option>
      </ion-select>
      <div
        *ngIf="getTitleErrorMessage()"
        class="fs-3 font500 padl10 ion-margin-vertical red-text-color"
      >
        {{ getTitleErrorMessage() }}
      </div>
      <ion-input
        formControlName="FirstName"
        [placeholder]="'shared.passenger_detail_form_v2.first_name_placeholder' | translate"
        name="FirstName"
        aria-label="FirstName"
        class="primary-input ion-margin-bottom fs-4"
        [class.field-error]="
          passengerForm.get('FirstName')?.invalid &&
          passengerForm.get('FirstName')?.touched
        "
        errorText=""
      ></ion-input>
      <ion-input
        formControlName="LastName"
        [placeholder]="'shared.passenger_detail_form_v2.last_name_placeholder' | translate"
        name="LastName"
        aria-label="LastName"
        class="primary-input ion-margin-bottom fs-4"
        [class.field-error]="
          passengerForm.get('LastName')?.invalid &&
          passengerForm.get('LastName')?.touched
        "
      ></ion-input>

      <ion-input
        formControlName="DateOfBirth"
        type="date"
        name="DateOfBirth"
        [min]="dobValidation?.min"
        [max]="dobValidation?.max"
        aria-label="DateOfBirth"
        class="primary-input ion-margin-bottom"
        [class.field-error]="
          passengerForm.get('DateOfBirth')?.invalid &&
          passengerForm.get('DateOfBirth')?.touched
        "
        (ionBlur)="onDobBlur()"
      >
        <div slot="label" class="fs-3 font400 date-label">
          {{ "shared.passenger_detail_form_v2.dob" | translate }} <span class="required-asterisk">*</span>
        </div></ion-input
      >
      <!-- Add this after your DateOfBirth input -->
      <div
        *ngIf="getDobErrorMessage()"
        class="fs-3 font500 padl10 ion-margin-vertical red-text-color"
      >
        {{ getDobErrorMessage() | translate }}
      </div>

      <ion-item
        *ngIf="partnerPid && partnerPid !== 'ent'"
        lines="none"
        [class.item-label]="!passengerForm.get('Nationality')?.value"
        [class.field-error]="
          passengerForm.get('Nationality')?.invalid &&
          passengerForm.get('Nationality')?.touched
        "
        (click)="presentCountrySelectionModal()"
        class="item-border ion-margin-bottom primary-input"
      >
        <ion-label
          [class.item-label]="!passengerForm.get('Nationality')?.value"
          >{{
            passengerForm.get("Nationality")?.value || ("shared.passenger_detail_form_v2.nationality_placeholder" | translate)
          }}</ion-label
        >
      </ion-item>

      <ion-text
        class="fs-3 font500 padl10 ion-margin-vertical"
        color="danger"
        *ngIf="dupPax"
        >{{ "shared.passenger_detail_form_v2.duplicate_passenger" | translate }}</ion-text
      >
    </ion-grid>
  </form>
  <div
    class="checkbox-container ion-bg-white d-flex ion-align-items-start ion-no-margin ion-margin-horizontal ion-margin-bottom"
    lines="none"
  >
    <ion-checkbox
      slot="start"
      class="ion-no-margin marr10 blue-checked-checkbox"
      [checked]="saveGuest"
      (ionChange)="saveGuest = $event.detail.checked"
      aria-labelledby="save-guest-label"
    ></ion-checkbox>
    <ion-label
      id="save-guest-label"
      class="fs-2 font500 ion-no-padding ion-no-margin l-height19 card-primary-text-color"
    >
      {{ "hotel.booking_review.save_guest" | translate }}
    </ion-label>
  </div>
</ion-content>
<ion-footer class="bg-white">
  <ion-button
    expand="block"
    class="primary-btn ion-margin fs-3 font500"
    mode="ios"
    (click)="handlePassengerDetails()"
  >
    {{ "shared.passenger_detail_form_v2.add_passenger" | translate }}
  </ion-button>
</ion-footer>
